var $ff2851f589effc46$exports = {};
const $ff2851f589effc46$var$twitchVideo = document.getElementById("twitch-vid");
document.getElementById("video-select").addEventListener("change", function() {
    let iframe = document.createElement("iframe");
    iframe.src = "https://www.youtube-nocookie.com/embed/" + document.getElementById("video-select").value;
    iframe.allowfullscreen = true;
    iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    document.getElementById("video-container").replaceChildren(document.getElementById("video-select").value ? iframe : $ff2851f589effc46$var$twitchVideo);
});


//# sourceMappingURL=videos.4454d9df.js.map
